export function chatroomsEnabled(hostname?: string): boolean {
  const host = (hostname
    || (typeof window !== 'undefined' ? window.location.hostname : '')
  ).toLowerCase();
  return host === 'skyspace.me'
    || host === 'staging.skyspace.me'
    || host === '127.0.0.1'
    || host === 'localhost';
}

export function chatRoomUri(ownerDid: string, panelId: string): string {
  return `at://${ownerDid}/me.skyspace.chat.room/${panelId}`;
}
